import { motion } from 'framer-motion';
import { levels } from '@/components/training/exerciseData';
import { cn } from '@/lib/utils';

export default function LevelSelector({ value, onChange }) {
  const colors = {
    beginner: 'from-emerald-400 to-teal-500',
    intermediate: 'from-blue-400 to-indigo-500',
    advanced: 'from-rose-400 to-pink-500',
  };

  return (
    <div className="space-y-3">
      <label className="block text-sm font-semibold text-slate-700">Experience Level</label>
      <div className="grid grid-cols-3 gap-3">
        {levels.map((level, index) => (
          <motion.button
            key={level.value}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.1 }}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            type="button"
            onClick={() => onChange(level.value)}
            className={cn(
              'relative p-4 rounded-2xl border-2 transition-all duration-300',
              'overflow-hidden',
              value === level.value
                ? 'border-transparent shadow-lg'
                : 'border-slate-200 bg-white hover:border-slate-300',
            )}
          >
            {value === level.value && (
              <motion.div
                layoutId="levelSelector"
                className={cn('absolute inset-0 bg-gradient-to-br opacity-10', colors[level.value])}
                initial={false}
                transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }}
              />
            )}
            <div className="relative flex flex-col items-center gap-1">
              <div
                className={cn(
                  'w-3 h-3 rounded-full mb-1',
                  value === level.value
                    ? `bg-gradient-to-br ${colors[level.value]}`
                    : 'bg-slate-300',
                )}
              />
              <span
                className={cn(
                  'font-semibold transition-colors',
                  value === level.value ? 'text-slate-800' : 'text-slate-600',
                )}
              >
                {level.label}
              </span>
              <span className="text-xs text-slate-500 hidden sm:block">{level.description}</span>
            </div>
          </motion.button>
        ))}
      </div>
    </div>
  );
}
